import React, { useContext } from 'react';

import { Box, styled } from '@mui/material';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import Button from 'components/Button';
import ArrowRight from 'components/SvgComponents/icons/ArrowRight';
import { OrganizationContext } from 'containers/GlobalWrapper/BusinessOrganizationDataValidation';
import { Routing } from 'routing/routing';
import globalMessages from 'translations/messages/global-messages';
import { authorizations } from 'utils/constants';

const Box_BannerWrapper = styled(Box, {
  shouldForwardProp: prop => prop !== 'fullWidth',
})(({ theme, fullWidth }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: 16,
  gap: theme.spacing(2),
  padding: theme.spacing(4, 6),
  justifyContent: 'space-between',
  backgroundColor: theme.palette.error.light,
  width: fullWidth ? '100%' : 800,
}));

const Typography_Subtitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

const Button_Upgrade = styled(Button)(() => ({
  '& .MuiButton-root': {
    marginInlineStart: 'auto',
  },
}));

export function OverFreemiumOfferBanner({ intl, fullWidth, blockItemsCreation, currentPlan }) {
  const businessOrganization = useContext(OrganizationContext);
  const history = useHistory();

  const canWriteOffer =
    businessOrganization?.authorizations?.indexOf(authorizations.organization.writeOffer) > -1;

  const onUpgradeOfferClick = () => {
    history.push(Routing.organizations.contract(businessOrganization?.id));
  };

  const isFreeOffer = currentPlan?.is_free === true;

  const getTitle = () => {
    if (isFreeOffer) {
      return intl.formatMessage(globalMessages.free_trial_limit_title);
    }
    return intl.formatMessage(globalMessages.other_offers_limit_title);
  };

  const getDescription = () => {
    if (isFreeOffer) {
      if (blockItemsCreation) {
        return canWriteOffer
          ? intl.formatMessage(globalMessages.free_trial_limit_elements_admin)
          : intl.formatMessage(globalMessages.free_trial_limit_elements_nonadmin);
      }
      return canWriteOffer
        ? intl.formatMessage(globalMessages.free_trial_limit_table_admin)
        : intl.formatMessage(globalMessages.free_trial_limit_table_nonadmin);
    }
    if (blockItemsCreation) {
      return canWriteOffer
        ? intl.formatMessage(globalMessages.other_offers_limit_elements_admin)
        : intl.formatMessage(globalMessages.other_offers_limit_elements_nonadmin);
    }
    return canWriteOffer
      ? intl.formatMessage(globalMessages.other_offers_limit_table_admin)
      : intl.formatMessage(globalMessages.other_offers_limit_table_nonadmin);
  };

  return (
    <Box_BannerWrapper fullWidth={fullWidth}>
      <div>
        <Typography component="p" variant="subtitleError">
          {getTitle()}
        </Typography>
        <Typography_Subtitle component="p" variant="subtitleLightBold">
          {getDescription()}
        </Typography_Subtitle>
      </div>
      {canWriteOffer && (
        <Button_Upgrade onClick={onUpgradeOfferClick} startIcon={<ArrowRight />} variant="danger">
          {intl.formatMessage(globalMessages.upgrade_offer_button_title)}
        </Button_Upgrade>
      )}
    </Box_BannerWrapper>
  );
}

OverFreemiumOfferBanner.propTypes = {
  intl: PropTypes.object.isRequired,
  fullWidth: PropTypes.bool,
  blockItemsCreation: PropTypes.bool,
  currentPlan: PropTypes.object.isRequired,
};

export default injectIntl(OverFreemiumOfferBanner);
